import React from 'react';
import { ApplyPresetConnected } from '../../containers/orders-drawer/sections/apply-preset';
import { BulkUpdate } from '../../components/orders-drawer/sections/bulk-update';

export const allSelectionComponentMap = [
  {
    name: 'ApplyPreset',
    v2Name: 'BulkPresets',
    render: () => <ApplyPresetConnected />,
  },
  {
    name: 'BulkUpdate',
    v2Name: 'BulkUpdate',
    render: () => <BulkUpdate />,
  },
];
